import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './ConfigService';
import { MasterService } from './master.service';
import { EnumOption } from '../models/EnumOption'
import { EnumAction } from '../models/EnumOption'
import { UriApi } from '../helpers/UriApi';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    api_sendotp = ConfigService.apiUrl + "/otp/sendotp";
    api_checkotp = ConfigService.apiUrl + "/otp/validateOTP";
    body = {
        request: {
            jsonParams: {},
            functionCode: 109,
            option: EnumOption.GetAll,
            data: "",
            dataList: "",
            menuCd: '',
            enumAction: EnumAction.View
        }
    };

    constructor(private http: HttpClient, private masterService: MasterService) { }


    signUp(data: any, option: any = EnumOption.Add) {
        this.body.request.data = data;
        this.body.request.option = option;
        return this.http.post(UriApi.api_user, this.body);
    }

    sendOTP(phonenumber: any) {
        let param = {
            phoneNumber: phonenumber
        }
        return this.http.post(this.api_sendotp, param);
    }

    validateOTP(phonenumber: any, otp: any) {
        let param = {
            phoneNumber: phonenumber,
            otp: otp
        }
        return this.http.post(this.api_checkotp, param);
    }

    getIdByPhone(Phone: any) {
        let params = new HttpParams().set('PhoneNumber', Phone);
        return this.http.get(UriApi.api_get_idbyphone, { params });
    }

    changePassword(Phone: any, Pass: any) {
        let param = {
            PhoneNumber: Phone,
            Password: Pass
        }
        return this.http.post(UriApi.api_updatepass, param);
    }

    changePasswordByUsername(Username: string, Pass: string, CurrentPassword: string) {
        let param = {
            CurrentPassword: CurrentPassword,
            UserName: Username,
            Password: Pass
        }
        return this.http.post(UriApi.api_updatepassbyusername, param);
    }

    updateProfile(param: any) {
        return this.http.post(UriApi.api_updateprofile, param);
    }

    updateLastLogin() {
        let param = {
            Lat: 0,
            Long: 0
        }

        this.masterService.postDataMasterNoLoading(109, param);
    }
}
